'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentBoxStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  labelPosition: _propTypes2.default.oneOf(['top', 'side'])
};

var defaultProps = {
  labelPosition: 'top'
};

/** Prop Receivers */
var contentFlow = function contentFlow(_ref) {
  var labelPosition = _ref.labelPosition;
  return labelPosition === 'side' && '\n    display: flex;\n    flex-direction: row;\n    align-items: flex-end;\n  ';
};

/** Styles */
var ContentBoxStyled = exports.ContentBoxStyled = _styledComponents2.default.div.withConfig({
  displayName: 'ContentBoxStyled'
})(['flex-grow:1;max-width:100%;', ';'], contentFlow);

ContentBoxStyled.propTypes = propTypes;
ContentBoxStyled.defaultProps = defaultProps;
ContentBoxStyled.displayName = 'ContentBoxStyled';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-selectbox/dist/styles/ContentBoxStyled.js
// module id = 224
// module chunks = 0